import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import PageHeaderComponent from '../../helpers/components/page_header.component';
import OrderListTable from './components/order_list_table';

const OrderList = () => {

    return (
        <>
            <ContainerComponent span={22} top={20}>
                <PageHeaderComponent />
                <OrderListTable />
            </ContainerComponent>
        </>
    );
}

export default OrderList;